/**
 * Same-origin BFF endpoints, relative to the mount point: callers wrap them in
 * withBase() (lib/basePath.ts) so they become '/admin/api/...' behind /admin.
 */
export const endpoints = {
  feedback: '/api/feedback',
  updates: '/api/product-updates',
};
